module.exports = __webpack_public_path__ + "static/media/matthew_serious.9d690970.png";